import { useContext } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import { modules } from "../../../index";
import { SIGNATURE_INTEGRATION_TYPES } from "../../../signature/Signature/config";
import { LenderApprovalStatus } from "@nemuru-eng/js-api-client";
import { assetTypes } from "../../../../shared/config";
import { documentStatus } from "../../../documentation/Documentation/config";
import {
  LOAN_APPLICATION_STATE,
  LOAN_STATUS,
} from "../../../../../config/config";

export const useApplicationInfoVideoId = (
  neededResponsesBeforeCheckModuleConditions,
  isAllowedLenderForKycVideo
) => {
  const {
    state: {
      loan,
      documentationRequired,
      editableDocumentationRequired,
      signatureChannel,
      participant,
    },
    dispatch,
  } = useContext(ProcessContext);

  const areDocumentsConfirmed = documentationRequired?.are_documents_confirmed;

  const loanId = loan?.id?.value ?? loan?.id;

  const areEditableRequiredFilesValidatedOrUploaded =
    editableDocumentationRequired &&
    editableDocumentationRequired.required_files.every(
      (file) =>
        file?.status === documentStatus.UPLOADED ||
        file?.status === documentStatus.VALIDATED
    );
  const isLenderApprovalStatusDifferentThanNo =
    loan?.loan_application_selected?.lender_fields?.loan_application_status
      ?.lender_approval_status !== LenderApprovalStatus.NO;

  const isLenderApprovalStatusYes =
    loan?.loan_application_selected?.lender_fields?.loan_application_status
      ?.lender_approval_status === LenderApprovalStatus.YES;

  const isLenderSelectedPendingApproval =
    !isLenderApprovalStatusYes &&
    loan?.loan_application_selected?.lender_fields?.loan_application_status
      ?.state === LOAN_APPLICATION_STATE.SELECTED;

  const isLoanAssetTypeOfTypeAuto =
    loan?.asset_reference[0].type === assetTypes.AUTO;

  const participantOnboardingDetails = participant.onboardingDetails;

  const dispatchActionAndSaveToNeededResponses = ({ actionName, payload }) => {
    neededResponsesBeforeCheckModuleConditions.push(actionName);
    dispatch({
      type: actionName,
      payload: payload,
    });
  };

  const isKycAlreadyCompleted = !!participant?.onboardingDetails?.kyc_id;

  const modulesInvolvedDefinitions = {
    [modules.DOCUMENTATION.id]: {
      requestNeededParamsToShow: () =>
        dispatchActionAndSaveToNeededResponses({
          actionName: "REQUEST_GET_DOCUMENTATION_REQUIRED",
          payload: {
            loanId,
            borrowerId: participant.participantId,
          },
        }),
      showConditions: () =>
        !areDocumentsConfirmed &&
        areEditableRequiredFilesValidatedOrUploaded !== true,
    },
    [modules.KYC_VIDEO_VERIFICATION.id]: {
      requestNeededParamsToShow: () =>
        dispatchActionAndSaveToNeededResponses({
          actionName: "REQUEST_GET_LOAN",
          payload: loanId,
        }),
      showConditions: () => {
        const result =
          isAllowedLenderForKycVideo &&
          !isKycAlreadyCompleted &&
          loan.status === LOAN_STATUS.STATUS_LENDER_HAS_BEEN_SELECTED;

        return result;
      },
    },
    [modules.OPTINS_AND_SIGNATURE.id]: {
      requestNeededParamsToShow: () =>
        dispatchActionAndSaveToNeededResponses({
          actionName: "REQUEST_GET_SIGNATURE_PARAMS_BY_LOAN_ID",
          payload: loanId,
        }),
      showConditions: () =>
        (signatureChannel?.integration_type ===
          SIGNATURE_INTEGRATION_TYPES.EMBEDDED_SAML ||
          signatureChannel?.integration_type ===
            SIGNATURE_INTEGRATION_TYPES.EMBEDDED ||
          signatureChannel?.integration_type ===
            SIGNATURE_INTEGRATION_TYPES.REDIRECT) &&
        !loan?.loan_application_selected?.loan_lender_borrower_contract
          ?.is_signed,
    },
  };

  return {
    isLenderSelectedPendingApproval,
    isLenderApprovalStatusDifferentThanNo,
    isLenderApprovalStatusYes,
    isLoanAssetTypeOfTypeAuto,
    modulesInvolvedDefinitions,
    participantOnboardingDetails,
    areEditableRequiredFilesValidatedOrUploaded,
  };
};
